<template>
	<v-dialog v-model="visible" persistent width="300px">
		<v-card>
			<v-card-title class="headline" v-html="dialogue.title">
			</v-card-title>
			<v-card-text v-html="dialogue.text">
			</v-card-text>
			<v-card-actions>
				<v-btn flat :icon="dialogue.iconNo" color="primary" @click="no">
					<v-icon v-if="dialogue.iconNo" small>{{dialogue.iconNo}}</v-icon>
					<span v-else>{{dialogue.textNo || "No"}}</span>
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn flat :icon="dialogue.iconYes" color="error" @click="yes">
					<v-icon v-if="dialogue.iconYes" small>{{dialogue.iconYes}}</v-icon>
					<span v-else>{{dialogue.textYes || "Yes"}}</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "FollowConfirmYesNo",
	
	props: ["show"],
	
	computed: {
		visible: {
			get () {
				return !!this.show;
			},
			set () {
				this.$emit('hide')
			}
		},
		
		dialogue () {
			return this.show instanceof Object
				? this.show
				: {};
		}
	},

	methods: {
		yes () {
			this.$emit('hide');
			typeof this.dialogue.actionYes == 'function' && this.dialogue.actionYes();
		},
		no () {
			this.$emit('hide');
			typeof this.dialogue.actionNo == 'function' && this.dialogue.actionNo();
		}
	}
}
</script>
